import React  from 'react'
import PropTypes from 'prop-types';
import Layouts from '../Layouts';
import classnames from 'classnames';
import styled from 'styled-components';

const Section = styled.section`
  color: ${({ color }) => color && color.color };
  background-color: ${({ bgColor }) => bgColor && bgColor.color };
  object-position: center;
  object-fit: ${({ objectFit }) => objectFit };
  height: calc(100vh - 100px);
  overflow: hidden;
  position: absolute;
  transform: translateY(100vh);
  transition: all 0.5s cubic-bezier(.22,.44,0,1);
  width: 100vw;
  will-change: transform;

  &:first-child {
    transform: translateY(50px);
    //transition: all 2s cubic-bezier(.22,.44,0,1);

    @media (min-width: 769px) {
      transform: translateY(100px);
    }
  }

  &:first-child {
    transform: translateY(50px);
    //transition: all 2s cubic-bezier(.22,.44,0,1);

    @media (min-width: 769px) {
      transform: translateY(100px);
    }
  }
  
  //
  //@media (min-aspect-ratio: 16/12) {
  //  height: calc(100vh - 100px);
  //}

  @media (max-width: 769px) {
    height: calc(100vh - 50px);
  }

  &.is-active {
    transform: translate3d(0, 50px, 0);

    @media (min-width: 769px) {
      transform: translate3d(0, 100px, 0);
    }
  }

  &.down-scroll {
    transform: translate3d(0,-50vh,0);
    //transition: all 1.2s cubic-bezier(.22,.44,0,1) .1s;

    @media (min-width: 769px) {
      transform: translate3d(0,-100vh,0);
    }
  }

  &:first-child {
    transform: translateY(50px);
    //transition: all 2s cubic-bezier(.22,.44,0,1);

    @media (min-width: 769px) {
      transform: translateY(100px);
    }

    &.down-scroll {
      transform: translate3d(0,calc(-100vh + 200px),0);

      @media (min-width: 769px) {
        transform: translate3d(0,calc(-100vh + 200px),0);
      }
    }
  }
`;

const Slide = (props)  => {

  const {
    bgColor,
    color,
    currentSlideNumber,
    deviceType,
    id,
    index,
    layouts,
    objectFit,
    supportsGrids,
    location
  } = props;

  const scrollDirection = Number(currentSlideNumber) <= index+1 ? 'up-scroll' : 'down-scroll';
  const isActive = index === Number(currentSlideNumber) - 1;
  const classes = [
    'c-folio__slide',
    `slide--${index + 1}`,
    {'is-active': isActive },
    scrollDirection
  ];

  return (
      <Section id={ id }
               className={ classnames(classes) }
               color={ color }
               bgColor={ bgColor }
               objectFit={ objectFit }
      >
        <Layouts layouts={ layouts } supportsGrids={ supportsGrids } deviceType={ deviceType }/>
      </Section>
  );
};

Slide.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  currentSlideNumber: PropTypes.number,
  deviceType: PropTypes.string,
  id: PropTypes.number,
  imageStyles: PropTypes.string,
  index: PropTypes.number,
  layouts: PropTypes.object,
  objectFit: PropTypes.string,
  slideBackgrounds: PropTypes.string,
  supportsGrids: PropTypes.bool,
};

export default Slide;



// WEBPACK FOOTER //
// ./src/components/Slide/index.js